import { API } from '../../../utils/api/index';
import {
  setEditingEmail,
  setEditingPhone,
  setEmailErrors,
  setPhoneErrors,
  setFormErrors,
} from '../user-profile/profileReducer';
import { setStatementAccounts, setLoading } from './deliveryPreferencesReducer';
import { setCustomer } from '../customer/customerReducer';

export const patchCustomerDetails = (customerId, body) => {
  return async (dispatch) => {
    dispatch(setLoading(true));
    await API.patch('customers/' + customerId, body)
      .then((response) => {
        dispatch(setCustomer(response.data));
        dispatch(setEditingEmail(false));
        dispatch(setEditingPhone(false));
        dispatch(setEmailErrors(null));
        dispatch(setPhoneErrors(null));
      })
      .catch((err) => {
        dispatch(setFormErrors(err.response?.data?.message));
      })
      .finally(() => dispatch(setLoading(false)));
  };
};
export const getStatementAccounts = (statementAccounts, setStatementAccountDeliveryPreferences) => {
  return async (dispatch) => {
    dispatch(setLoading(true));
    let promises = statementAccounts.map((account) => {
      return API.get(`statementAccounts/${account.fullAccount.statementAccountRef}`)
        .then((response) => response.data)
        .catch((err) => err);
    });
    return Promise.allSettled(promises)
      .then((response) => {
        let accounts = response.map((response) => response.value);
        let accountsFiltered = accounts?.map((account) => {
          let matched = statementAccounts.find(
            (thisAccount) => thisAccount.fullAccount.systemId === account?.statementFeeAccountRef,
          );
          return {
            deliveryPreference: account.preferredDeliveryMethod,
            accountDisplayNumber: matched.fullAccount.accountDisplayNumber,
            systemId: matched.fullAccount.systemId,
          };
        });
        setStatementAccountDeliveryPreferences(accountsFiltered);
        dispatch(setStatementAccounts(accounts));
      })
      .catch((err) => {
        dispatch(setFormErrors(err?.response?.data?.message));
      })
      .finally(() => dispatch(setLoading(false)));
  };
};
export const updateStatementAccounts = (accountsToUpdate, fullStatementAccountList, notify) => {
  return async (dispatch) => {
    for (const policy of accountsToUpdate) {
      let currentPolicy = fullStatementAccountList.find(
        (thisPolicy) => thisPolicy.statementFeeAccountRef === policy.systemId,
      );
      let body = {
        ...currentPolicy,
        preferredDeliveryMethod: policy.deliveryPreference,
        // _revision: policy._revision,
      };
      return API.patch(`/statementAccounts/${currentPolicy.systemId}`, body)
        .then(() => {
          notify(
            `Your policy preferences have been updated for ${currentPolicy.statementAccountDisplayNumber}`,
            {
              variant: 'success',
              anchorOrigin: {
                horizontal: 'center',
                vertical: 'top',
              },
            },
          );
        })
        .catch((err) => {
          console.log(err);
          notify(
            `Your policy preferences were unable to be updated for ${currentPolicy.statementAccountDisplayNumber} ${err?.response?.data?.message}`,
            {
              variant: 'error',
              anchorOrigin: {
                horizontal: 'center',
                vertical: 'top',
              },
            },
          );
        });
    }
  };
};
